<template>
  <div class="page">
    <ClientsSectionTabs action-text="+ Добавить администратора" action-permission="add_admin" @action="setDialogCreateShow(true)" />
    <div v-if="!inClientsSection" class="row">
      <div class="col-7 d-flex align-center">
        <h1 class="font-lg">Администраторы</h1>
      </div>
      <div class="col-5 d-flex align-center" v-if="$store.getters['auth/isAllowed']('add_admin')">
        <v-btn class="primary ml-auto mr-2" small fab @click="setDialogCreateShow(true)">
          <v-icon small>mdi-account-plus</v-icon>
        </v-btn>
      </div>
      <!-- <div class="col-5 d-md-none d-flex align-center">
        <v-btn class="ml-auto mr-2 d-sm-none" small fab @click="setDialogCreateShow(true)">
          <v-icon small>mdi-timer</v-icon>
        </v-btn>
        <v-btn color="primary d-sm-none" small fab @click="setDialogCreateShow(true)">
          <v-icon small>mdi-account-plus</v-icon>
        </v-btn>

        <v-btn class="ml-auto mr-2 d-none d-sm-block" fab @click="setDialogCreateShow(true)">
          <v-icon small>mdi-timer</v-icon>
        </v-btn>
        <v-btn color="primary d-none d-sm-block" fab @click="setDialogCreateShow(true)">
          <v-icon small>mdi-account-plus</v-icon>
        </v-btn>
      </div> -->
    </div>

    <!-- <div class="row d-none d-md-flex mb-8">
      <div class="col-md-10 col-lg-9">
          <ExpressSendTest />
      </div>

      <div class="col-md-2 col-lg-3 d-flex align-center">
        <v-btn class="ml-auto" color="primary" fab @click="setDialogCreateShow(true)">
          <v-icon>mdi-account-plus</v-icon>
        </v-btn>
      </div>
    </div> -->
    <div class="row">
      <div class="col-12">
        <AdminsTable />
      </div>
    </div>

    <!-- <v-speed-dial v-if="selected.length" v-model="adminsActionsFAB"
                  class="button-fab d-sm-none"
                  bottom right direction="top"
                  transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn v-model="adminsActionsFAB" color="#25325F" dark fab>
          <v-icon v-if="adminsActionsFAB">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="primary" class="icon bg-main" outlined>
        <v-icon color="#9BA1B5">mdi-share</v-icon>
      </v-btn>
      <v-btn fab dark small color="primary" class="icon bg-main" outlined
             :loading="loading.loadResults" @click="exportToTable">
        <v-icon color="#9BA1B5">mdi-upload</v-icon>
      </v-btn>
      <v-btn fab dark small color="primary" class="icon bg-main" @click="dialogDeleteShow = true" outlined>
        <v-icon color="#9BA1B5">mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial> -->

    <!-- <DialogDelete v-model="dialogDeleteShow"/> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ClientsSectionTabs from '@/components/clients/ClientsSectionTabs.vue';
import { allowedClientsSectionTabs } from '@/common/constants/clientsSection';
import AdminsTable from '@/components/admins/AdminsTable';
import exportToTableMixin from '@/components/candidates/table/exportToTableMixin';
// import DialogDelete from '@/components/admins/DialogDelete';

export default {
  name: 'Admins',
  mixins: [exportToTableMixin],
  metaInfo: {
    title: 'Администраторы',
  },
  components: {
    ClientsSectionTabs,
    AdminsTable,
    // DialogDelete,
  },
  data: () => ({
    adminsActionsFAB: false,
    dialogDeleteShow: false,
  }),
  computed: {
    // У админа заголовок и кнопка — в шапке раздела «Клиенты»
    inClientsSection() {
      return allowedClientsSectionTabs(this.$store).length > 0;
    },
    ...mapGetters({
      loading: 'users/admins/loading',
      selected: 'users/admins/selected',
    }),
  },
  methods: {
    ...mapActions({
      setSelected: 'users/admins/setSelected',
      setDialogCreateShow: 'users/admins/setDialogCreateShow',
    }),
  },
  beforeDestroy() {
    this.setSelected(null);
  },
};
</script>
